import React from "react";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import InterviewResultsCandidatesTableRow from "./InterviewResultsCandidatesTableRow";
import { EmptyState, TableLoading } from "../../../common";
import { interview_candidates_table_columns } from "../../../static/table-columns";

const InterviewResultsCandidatesTable = ({
  page,
  getData,
  tableData,
  isLoading,
}) => {
  const isEmpty = tableData ? tableData?.length === 0 : false;

  return (
    <Card
      sx={{
        border: 1,
        height: { xs: "40%", sm: "55%", md: "65%", lg: "75%" },
        mb: 1,
        overflow: "auto",
        borderColor: "#CFCFCF",
        width: "100%",
        borderRadius: "12px",
      }}
    >
      <TableContainer
        sx={{
          maxHeight: "100%",
          maxWidth: "100%",
          fontFamily: "Outfit",
          overflow: "auto",
          "& .MuiTableRow-root:hover": { backgroundColor: "primary.200" },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {interview_candidates_table_columns?.map((column, i) => (
                <TableCell
                  key={column.id}
                  align="left"
                  sx={{
                    minWidth: i === 0 ? "20px" : "200px",
                    bgcolor: "white",
                  }}
                >
                  <Typography
                    fontSize={{ xs: "14px", md: "16px" }}
                    fontWeight={600}
                    color="#21282F"
                  >
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
              {!isEmpty || (!isLoading && <TableCell></TableCell>)}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableLoading noOfColumns={9} />
            ) : (
              tableData?.map((id) => (
                <InterviewResultsCandidatesTableRow
                  key={id}
                  id={id}
                  getData={getData}
                  page={page}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isEmpty && !isLoading && (
        <EmptyState description="Looks like there's no interviews found. Try adjusting your filters" />
      )}
    </Card>
  );
};

export default InterviewResultsCandidatesTable;
